import React from "react";
import ActionBtnU from "../../../screens/User/Users/components/ActionBtnU";

interface ErrorMessageProps {
  onExit: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ onExit }) => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <p>
        This form could not be loaded. Click retry to attempt a reload. If it
        still fails, it may no longer exist. Please contact support.
      </p>
      <div className="mt-4 flex justify-center gap-4">
        <ActionBtnU purpleBg white_color onClick={handleRetry}>
          Retry{" "}
        </ActionBtnU>
        <ActionBtnU purple_border onClick={onExit}>
          Exit
        </ActionBtnU>
      </div>
    </div>
  );
};

export default ErrorMessage;
